import Button from "./Button";
import {useContext, useEffect, useState} from "react";
import useSubscriptionApiService from "../Hooks/useSubscriptionApiService";
import {DataContext} from "../Context/DataContext";

const FreeSubButton = ({btnText}: { btnText?: string }) => {
    const {isLoading: isMainDataLoading, nextFreeSubscriptionAt} = useContext(DataContext);
    const {claimFreeSubscription, isLoading} = useSubscriptionApiService();
    const [now, setNow] = useState(Date.now());
    const remaining = nextFreeSubscriptionAt ? Math.max(0, Math.ceil((Date.parse(nextFreeSubscriptionAt) - now) / 1000)) : 0;

    useEffect(() => {
        const timer = window.setInterval(() => setNow(Date.now()), 1000);
        return () => window.clearInterval(timer);
    }, []);

    const clickHandler = async () => {
        if (isLoading || isMainDataLoading || remaining > 0)
            return;

        const result = await claimFreeSubscription();
        if (result && !result.error)
            window.location.reload();
    }

    const days = Math.floor(remaining / 86400);
    const hours = Math.floor(remaining / 3600) % 24;
    const minutes = Math.floor(remaining / 60) % 60;
    const seconds = remaining % 60;
    const countdown = `${days} · ${[hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':')}`;

    return <Button onClick={clickHandler} color={'green'} circular loading={isLoading || isMainDataLoading} disabled={remaining > 0}>
        {remaining > 0 ? `${btnText || 'Free subscription'} · ${countdown}` : btnText || 'Free subscription'}
    </Button>
}

export default FreeSubButton;
